import { type ComputedRef } from "vue";
import type { StatusIndicator } from "@/components/platformcapabilities/types";
import { CapabilityStatus } from "@/components/platformcapabilities/constants";
import routeLinks from "@/router/routeLinks";

export interface CapabilityComposable {
  status: ComputedRef<CapabilityStatus>;
  description: ComputedRef<string>;
  indicators: ComputedRef<StatusIndicator[]>;
  isLoading: ComputedRef<boolean>;
  helpButtonText: ComputedRef<string>;
  helpButtonUrl: ComputedRef<string>;
}

export type CapabilityStatusToStringMap = Partial<Record<CapabilityStatus, string>>;

export function useCapabilityBase() {
  const getDescriptionForStatus = (status: CapabilityStatus, descriptions: CapabilityStatusToStringMap): string => {
    return descriptions[status] ?? "";
  };

  const getHelpButtonTextForStatus = (status: CapabilityStatus, helpButtonTexts: CapabilityStatusToStringMap): string => {
    return helpButtonTexts[status] || "Learn More";
  };

  const getHelpButtonUrlForStatus = (status: CapabilityStatus, helpButtonUrls: CapabilityStatusToStringMap): string => {
    return helpButtonUrls[status] || routeLinks.dashboard;
  };

  const createIndicator = (label: string, status: CapabilityStatus, tooltip: string, url?: string, version?: string): StatusIndicator => {
    let fullTooltip = tooltip;
    if (url) {
      fullTooltip = `${fullTooltip} - ${url}`;
    }
    if (version && version !== "Unknown") {
      fullTooltip = `${fullTooltip} - v${version}`;
    }
    return {
      label,
      status,
      tooltip: fullTooltip,
    };
  };

  return {
    getDescriptionForStatus,
    getHelpButtonTextForStatus,
    getHelpButtonUrlForStatus,
    createIndicator,
  };
}
